// Typical statutory weekly overtime thresholds. Informational only — not legal advice.
const CA_PROVINCES = {
  'Ontario': { hours: 44, law: 'ESA' },
  'Alberta': { hours: 44, law: 'ESC' },
  'New Brunswick': { hours: 44, law: 'ESA' },
  'British Columbia': { hours: 40, law: 'ESA' },
  'Quebec': { hours: 40, law: 'LNT' },
  'Manitoba': { hours: 40, law: 'ESC' },
  'Saskatchewan': { hours: 40, law: 'SEA' },
  'Newfoundland and Labrador': { hours: 40, law: 'LSA' },
  'Yukon': { hours: 40, law: 'ESA' },
  'Northwest Territories': { hours: 40, law: 'ESA' },
  'Nunavut': { hours: 40, law: 'LSA' },
  'Nova Scotia': { hours: 48, law: 'Labour Standards Code' },
  'Prince Edward Island': { hours: 48, law: 'ESA' },
};

export const getOtThresholdHint = (country, state) => {
  if (country === 'US') {
    return { hours: 40, label: `US federal FLSA (${state || 'all states'})` };
  }
  if (country === 'CA') {
    const p = CA_PROVINCES[state];
    if (p) return { hours: p.hours, label: `${state} ${p.law}` };
    return { hours: 40, label: 'Canada federal (CLC)' };
  }
  if (country === 'MX') {
    return { hours: 48, label: 'Mexico federal LFT' };
  }
  return null;
};
